var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "template-page" }, [_vm._v(" 我是全局规则 ")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }